import { Phone, Mail, MapPin, Clock, Instagram, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND, whatsappUrl } from "@/lib/site-data";
import useSeo from "@/lib/useSeo";

export default function Contact() {
  useSeo({
    title: "İletişim | Epersonel",
    description:
      "Dijital satış operasyonunuzu birlikte planlayalım. Telefon, WhatsApp, e-posta ve sosyal medya üzerinden Epersonel ekibine ulaşın.",
  });
  return (
    <>
      <section className="pt-16 pb-10">
        <div className="ep-container max-w-4xl">
          <p className="text-xs tracking-[0.3em] text-[#00F22E] font-medium mb-4">
            İLETİŞİM
          </p>
          <h1 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight">
            Dijital Satış Operasyonunuzu{" "}
            <span className="text-[#00F22E]">Birlikte Planlayalım.</span>
          </h1>
          <p className="mt-5 text-white/85 text-base md:text-lg leading-relaxed max-w-2xl">
            İşyerinizin mevcut durumunu ve ihtiyaçlarını paylaşın. Ekibimiz
            size uygun pazaryeri, sipariş sistemi, entegrasyon ve kurye
            çözümlerini değerlendirsin.
          </p>
        </div>
      </section>

      <section className="py-10">
        <div className="ep-container grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          <div className="ep-card p-6">
            <div className="w-10 h-10 rounded-xl bg-[#00F22E]/10 text-[#00F22E] grid place-items-center mb-4">
              <Phone className="h-5 w-5" />
            </div>
            <div className="text-sm text-muted">Telefon ve WhatsApp</div>
            <a
              href={`tel:+${BRAND.contact.phoneRaw}`}
              className="mt-1 block font-display font-semibold text-lg hover:text-[#00F22E]"
              data-testid="contact-phone"
            >
              {BRAND.contact.phone}
            </a>
          </div>
          <div className="ep-card p-6">
            <div className="w-10 h-10 rounded-xl bg-[#00F22E]/10 text-[#00F22E] grid place-items-center mb-4">
              <Mail className="h-5 w-5" />
            </div>
            <div className="text-sm text-muted">E-posta</div>
            <a
              href={`mailto:${BRAND.contact.email}`}
              className="mt-1 block font-display font-semibold text-lg hover:text-[#00F22E]"
              data-testid="contact-email"
            >
              {BRAND.contact.email}
            </a>
          </div>
          <div className="ep-card p-6">
            <div className="w-10 h-10 rounded-xl bg-[#00F22E]/10 text-[#00F22E] grid place-items-center mb-4">
              <MapPin className="h-5 w-5" />
            </div>
            <div className="text-sm text-muted">Konum</div>
            <div className="mt-1 font-display font-semibold text-lg">
              {BRAND.contact.location}
            </div>
          </div>
          <div className="ep-card p-6">
            <div className="w-10 h-10 rounded-xl bg-[#00F22E]/10 text-[#00F22E] grid place-items-center mb-4">
              <Clock className="h-5 w-5" />
            </div>
            <div className="text-sm text-muted">Çalışma Saatleri</div>
            <div className="mt-1 font-display font-semibold text-base">
              {BRAND.contact.hours}
            </div>
          </div>
        </div>
      </section>

      <section className="py-10">
        <div className="ep-container flex flex-wrap gap-3 items-center">
          <a href={whatsappUrl()} target="_blank" rel="noopener noreferrer" className="btn-primary" data-testid="contact-whatsapp">
            WhatsApp'tan Görüşelim
          </a>
          <Link to="/basvuru" className="btn-secondary" data-testid="contact-analysis">
            Ücretsiz Analiz İste
          </Link>
          <div className="ml-auto flex items-center gap-3">
            <a
              href={`https://instagram.com/${BRAND.contact.instagram}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-white/10 text-white/80 hover:text-[#00F22E] hover:border-[#00F22E] transition-colors"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a
              href={`https://linkedin.com/company/${BRAND.contact.linkedin}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-white/10 text-white/80 hover:text-[#00F22E] hover:border-[#00F22E] transition-colors"
            >
              <Linkedin className="h-4 w-4" />
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
